<template>
  <div class="login">
    <div class="login_title">
      <p class="tw-text-[20px]">欢迎登录</p>
    </div>
    <div class="login_form">
      <el-form
        ref="form"
        :model="form"
        :rules="rules">
        <el-form-item prop="mobile">
          <el-input
            v-model.trim="form.mobile"
            :maxlength="11"
            placeholder="请输入手机号">
          </el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          @keydown.native.enter="handleLogin">
          <el-input
            type="password"
            v-model.trim="form.password"
            placeholder="请输入密码"
            show-password>
          </el-input>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        style= "width:320px;"
        :loading="btnLoading"
        @click="handleLogin">
        立即登录
      </el-button>
    </div>
    <div class="forget-reg">
      <button
        class="forget_pws"
        @click="$emit('change-form', 'forget')">
        忘记密码
      </button>
      <button
        class="free-reg"
        @click="$emit('change-form','register')">
        免费注册
      </button>
    </div>
    <div class="login-message">
      <span>当前平台处于试运营期间，如有问题，可联系本公司工作人员反馈</span>
    </div>
    <div class="content-logo-hidden">
      <img src="@/assets/images/content-logo-hidden.png" alt="">
    </div>
    <div class="home-content-right">
      <img src="@/assets/images/center-right.png" alt="">
    </div>
    <div class="right-hidden">
      <img src="@/assets/images/right-hidden.png" alt="">
    </div>
  </div>
</template>

<script>
import api from '@/api'
import cookie from '@/plugins/cookie'
import globalVar from '@/configs/globalVar'
import SHA256 from 'crypto-js/sha256'
export default {
  data () {
    return {
      form: {
        mobile: '', // 手机号
        password: '' // 密码
      },
      // 表单验证规则
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}$/, message: '密码长度为8~16位，至少需要包含数字、字母', trigger: 'blur' }
        ]
      },
      btnLoading: false
    }
  },
  methods: {
    // 进行登录
    handleLogin () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          api.frontLogin({
            mobile: this.form.mobile,
            password: SHA256(this.form.password).toString()
          }).then(res => {
            this.btnLoading = false
            if (res.data.code === 0) {
              cookie.set(globalVar.TOKEN, res.data.data.token)
              this.$store.commit('setUserInfo', res.data.data.user)
              if (res.data.data.user.role === 0) {
                this.$router.push('/user')
              } else {
                this.$router.push('/company')
              }
            } else if (res.data.code === 10130) {
              console.log(res)
              cookie.set(globalVar.TOKEN, res.data.data.token)
              this.$router.push('/middle-login')
            } else {
              this.$message.error('请检查账号密码是否正确')
            }
          }).catch((error) => {
            this.btnLoading = false
            console.log(error)
            this.$message.error('请求出错')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
    position: relative;
    top: 50px;
    width:500px;
    height: 600px;
    padding: 50px 90px;
    border: 1px solid #fff;
    background-color:rgba(254, 254, 254, 1);
    border-radius: 4px;
    .login_title {
      width: 210px;
      height: 28px;
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      color: #000000;
    }
    .login_form {
      margin-top:36px;
    }
    .forget-reg {
      margin-top: 12px;
      margin-left: 175px;
    }
    .forget_pws {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 0px;
      color: #909399;
      margin-right: 27px;
    }
    .free-reg {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #909399;
    }
    .login-message {
      position:absolute;
      bottom:36px;
      width: 320px;
      height: 60px;
      font-size: 12px;
      font-weight: 400;
      padding: 10px 10px 0px 10px;
      color: #909399;
      border-top: 1px solid #DCDFE6;
    }
    .content-logo-hidden{
      position: absolute;
      width: 80px;
      top: 0px;
      left: -1px;
    }
    .home-content-right {
      position: absolute;
      right:-96px;
      bottom: -100px;
    }
    .right-hidden {
      position: absolute;
      right: 0px;
      bottom:0px;
    }
  }
</style>
